// Copyright 2026 TokenLat. Licensed under the Apache License, Version 2.0.
import { useEffect } from 'react';

import {
  invalidateModelCatalog,
  onOpenTokenLatSettings,
} from '@coze-arch/bot-api/model-catalog';

import { useAccountSettings } from '.';

// Mounted even in editors without a sidebar; retain the underlying creation form.
export const TokenSettingsHost = () => {
  const { node, open } = useAccountSettings({
    onClose: invalidateModelCatalog,
    zIndex: 1300,
  });
  useEffect(() => onOpenTokenLatSettings(() => open('tokenlat-keys')), [open]);
  return node;
};
